"use client";

import { message } from "antd";
import type { MessageApi, Notify } from "../feedback/types";
import { createNotify, Ctx } from "../feedback";

export function AppMessageProvider({ children }: { children: React.ReactNode }) {
    const [api, holder] = message.useMessage();
    return (
        <Ctx.Provider value={api}>
            {holder}
            {children}
        </Ctx.Provider>
    );
}

export const GlobalMessage: Notify = createNotify(message as unknown as MessageApi);
